<template>
    <div>
        <div style="display:flex; gap:12px; align-items:center; margin-bottom:12px;">
            <el-input
                v-model="form.keyword"
                placeholder="Nhập mã, tên khách hàng"
                prefix-icon="el-icon-search"
                clearable
                @input="onSearchInput"
                style="width: 280px;"
            />

            <el-input
                v-model="form.phone"
                type="number"
                placeholder="Nhập số điện thoại khách hàng"
                prefix-icon="el-icon-phone"
                clearable
                @input="onSearchInput"
                style="width: 280px;"
            />

            <el-select
                v-model="form.status"
                placeholder="Chọn trạng thái"
                clearable
                style="width: 200px;"
                @change="onStatusChange"
            >
                <el-option
                    v-for="item in listStatusTask"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                />
            </el-select>
        </div>

        <div>
            <div class="d-flex justify-content-end">
                <el-dropdown @command="handleDropdownCommand">
                    <el-button type="primary" size="mini">
                        Hành động<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="task_calendar">Task calendar</el-dropdown-item>

                    </el-dropdown-menu>
                </el-dropdown>
            </div>
<!--                <router-link :to="{ name: 'calendar-task' }" class=" d-flex justify-content-end">-->
<!--                    <el-tooltip content="Chuyển sang trang task việc" placement="top">-->
<!--                        <button class="btn btn-info btn-sm btn-icon waves-effect waves-themed mr-2 text-center">-->
<!--                            <i class="el-icon-tickets"></i>-->
<!--                        </button>-->
<!--                    </el-tooltip>-->
<!--                </router-link>-->
        </div>


        <!-- Bảng dữ liệu -->
        <el-table :data="localTableData" style="width: 100%" :loading="loading">
            <el-table-column prop="id" label="Task id" />
            <el-table-column prop="customer.id" label="Khách hàng id" />
            <el-table-column prop="customer.name" label="Tên Khách hàng" />
            <el-table-column prop="customer.phone" label="Số điện thoại" />
            <el-table-column prop="created_user.name" label="Người tạo task" />
            <el-table-column label="Trạng thái">
                <template v-slot="scope">
                    <el-button
                        :type="taskMeta(scope.row.status).type"
                        size="mini"
                    >
                        {{ taskMeta(scope.row.status).label }}
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="Thời gian tạo">
                <template v-slot="scope">
                    {{ scope.row.created_at | formatDate }}
                </template>
            </el-table-column>

            <el-table-column label="Deadline">
                <template v-slot="scope">
                    {{ scope.row.deadline | formatDate }}
                </template>
            </el-table-column>

            <el-table-column label="Hành động" width="180">
                <template v-slot="scope">
                    <el-tooltip content="Xem chi tiết" placement="top">
                        <button
                            @click="showDetailTask(scope.row.task_content)"
                            class="btn btn-primary btn-sm btn-icon waves-effect waves-themed mr-2 text-center"
                        >
                            <i class="fa fa-pencil"></i>
                        </button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <!-- Phân trang -->
        <div class="mt-3" style="display:flex; justify-content:center;">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page.sync="paging.current_page"
                :page-size="paging.per_page"
                layout="prev, pager, next"
                :total="paging.total"
            />
        </div>
        <el-dialog
            title="Chi tiết task"
            :visible.sync="dialogDetailTask"
            width="800px"
            append-to-body
            class="task-detail-dialog"
        >
            <div class="task-detail-wrapper">
                <div class="task-detail-label">Nội dung công việc:</div>

                <div class="task-detail-box" v-html="taskDetailHtml"></div>
            </div>

            <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogDetailTask = false">Hủy</el-button>
    </span>
        </el-dialog>
    </div>
</template>

<script>
import { GET_TASK_SALE } from "@/core/services/store/customer/customer.module";
import debounce from "lodash/debounce";

export default {
    name: 'DialogHandleTask',
    props: {
        is_show: { type: Boolean, default: false },
        tableData: {
            type: Array,
            default: () => []
        },
        is_dashboard: { type: Boolean, default: false },
    },
    data() {
        return {
            localTableData: [],

            form: {
                keyword: '',
                phone: '',
                status: ''
            },
            paging: {
                current_page: 1,
                per_page: 10,
                total: 0,
            },
            task_meta: {
                1: { type: 'info',    label: 'Chưa xử lý' },
                2: { type: 'warning', label: 'Đang xử lý' },
                3: { type: 'success', label: 'Hoàn thành' },
            },
            default_meta: {
                type: 'info',
                label: 'Không xác định'
            },
            loading: false,
            dialogDetailTask: false,
            taskDetail: '',
            debouncedSearch: null,
            listStatusTask: [
                { label: 'Chưa xử lý', value: 1 },
                { label: 'Đang xử lý', value: 2 },
            ],
        }
    },
    created() {
        this.debouncedSearch = debounce(this.getTaskWithCustomer, 400);
    },
    computed: {
        taskDetailHtml() {
            if (!this.taskDetail) return '';
            return this.taskDetail.replace(/\n/g, '<br>');
        }
    },
    watch: {
        tableData: {
            immediate: true,
            handler(val) {
                this.localTableData = Array.isArray(val) ? val : [];
            }
        },
        is_show: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.paging.current_page = 1;
                    this.getTaskWithCustomer();
                } else {
                    this.resetFormAndData();
                }
            }
        }
    },
    methods: {
        resetFormAndData() {
            this.localTableData = [];
            this.form.keyword = '';
            this.form.phone = '';
            this.form.status = '';
            this.paging.current_page = 1;
            this.paging.total = 0;
        },

        onSearchInput() {
            this.paging.current_page = 1;
            this.debouncedSearch();
        },

        onStatusChange() {
            this.paging.current_page = 1;
            this.getTaskWithCustomer();
        },

        getTaskWithCustomer() {
            if (!this.is_show) return; // tránh call khi dialog đã đóng

            this.loading = true;

            this.$store.dispatch(GET_TASK_SALE, {
                keyword: this.form.keyword,
                phone: this.form.phone,
                status: this.form.status,
                page: this.paging.current_page,
                per_page: this.paging.per_page,
            })
                .then(res => {
                    this.localTableData = res.data || [];

                    this.paging.current_page = res.current_page || this.paging.current_page;
                    this.paging.per_page    = res.per_page || this.paging.per_page;
                    this.paging.total       = res.total || this.paging.total;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        handleCurrentChange(page) {
            this.paging.current_page = page;
            this.getTaskWithCustomer();
        },

        taskMeta(status) {
            return this.task_meta[status] || this.default_meta;
        },

        showDetailTask(item) {
            this.taskDetail = item;
            this.dialogDetailTask = true;
        },

        handleDropdownCommand(command) {
            if (command === 'task_calendar') {
                this.$router.push({ name: 'calendar-task' });
            }
        }
    },
}
</script>

<style>
.task-detail-wrapper {
    margin-top: 4px;
}

.task-detail-label {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 6px;
}

.task-detail-box {
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 14px;
    line-height: 1.6;
    color: #303133;

    max-height: 220px;
    overflow-y: auto;
}

.task-detail-box::-webkit-scrollbar {
    width: 6px;
}

.task-detail-box::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #c0c4cc;
}
</style>
